import { render } from "./ServicesApp.vue?vue&type=template&id=6f5731f2&scoped=true"
import script from "./ServicesApp.vue?vue&type=script&lang=js"
export * from "./ServicesApp.vue?vue&type=script&lang=js"

import "./ServicesApp.vue?vue&type=style&index=0&id=6f5731f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5731f2"]])

export default __exports__